import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import dayjs from "dayjs";
import "dayjs/locale/tr";
import "dayjs/locale/it";
import "dayjs/locale/es";
import "dayjs/locale/de";
import "dayjs/locale/ar";
import firebase from "./FirebaseConfig";
import {
  APP_LANGUAGE_CODES,
  applyDocumentLanguage,
  languageFromSearch,
  normalizeAppLanguage,
  resolveInitialAppLanguage,
} from "util/locale";

function applyFirebaseAuthLanguage(language) {
  try {
    firebase.auth().languageCode = normalizeAppLanguage(language);
  } catch {
    // Auth may not be ready in some test/SSR contexts.
  }
}

function applyDayjsLocale(language) {
  const code = normalizeAppLanguage(language);
  dayjs.locale(code === "en" ? "en" : code);
}

const fromQuery = languageFromSearch(window.location.search);
const storedRaw = window.localStorage.getItem("userLang");
const stored = resolveInitialAppLanguage({
  search: window.location.search,
  stored: storedRaw,
});
if (fromQuery) {
  window.localStorage.setItem("userLang", fromQuery);
}

i18n
  .use(initReactI18next)
  .use(Backend)
  .init(
    {
      lng: stored,
      fallbackLng: {
        default: ["en"],
        it: ["en"],
        es: ["en"],
        de: ["en"],
        ar: ["en"],
        tr: ["en"],
      },
      supportedLngs: APP_LANGUAGE_CODES,
      nonExplicitSupportedLngs: true,
      load: "languageOnly",
      debug: false,
      backend: {
        loadPath: "/assets/locales/{{lng}}/translation.json",
      },
      interpolation: {
        escapeValue: false,
      },
    },
    (err) => {
      if (err) {
        console.error("Error initializing i18next:", err);
      } else {
        applyDocumentLanguage(i18n.language);
        applyDayjsLocale(i18n.language);
        applyFirebaseAuthLanguage(i18n.language);
      }
    }
  );

i18n.on("languageChanged", (lng) => {
  applyDocumentLanguage(lng);
  applyDayjsLocale(lng);
  applyFirebaseAuthLanguage(lng);
});

export default i18n;
